<template>
  <div class="ride-workflow-data main">
    <div class="wrapper" v-if="workflow">
      <!-- <button class="delete is-large" @click="$emit('close')" /> -->
      <h1 class="subtitle" @click="$emit('close')">
        <i class="fa fa-chevron-left fa-lg has-text-warning" />&nbsp;
        {{ shortenString(business.name, 35) }}
        <i
          class="fa fa-pencil-alt is-pulled-right has-text-success"
          @click="gotoBusinessProfile"
        />
      </h1>
      <div class="table-wrapper no-scrollbar">
        <table class="table is-fullwidth">
          <tr>
            <td colspan="2">
              <span class="top-row no-scrollbar">
                <span class="tag is-light">
                  <span v-if="isActive" class="has-text-success">Active</span>
                  <span v-else class="has-text-danger">Inactive</span>
                </span>
                <span class="tag is-info" @click="showPickupArea">
                  Pickup Area
                </span>
                <span v-if="blurb" class="tag is-dark" @click="showBlurb">
                  Blurb
                </span>
                <span v-if="hasTours" class="tag is-success" @click="showTours">
                  Tours
                </span>
                <span v-if="anyLocation" class="tag is-warning">
                  Any Location
                </span>
                <span v-if="requiresUnitNumber" class="tag is-warning">
                  Requires Unit #
                </span>
              </span>
            </td>
          </tr>
          <tr v-for="(value, key) in tableData" :key="key" @click="edit(key)">
            <td class="key is-narrow">{{ key }}</td>
            <td v-html="value"></td>
            <!-- <td :class="clickable(key)" v-html="value"></td> -->
          </tr>
        </table>
      </div>

      <RideWorkflowMap :workflow="workflow" />
      <span class="updated tag is-dark">Updated {{ updated }}</span>
    </div>
  </div>
</template>

<script>
import RideWorkflowMap from "@/components/RideWorkflowMap.vue";

export default {
  components: {
    RideWorkflowMap,
  },
  props: {
    workflow: Object, // workflow
  },
  data() {
    return {
      updatedWorkflow: null, // store update here
      moreInfo: null,
      mapURL: null,
      fallbackRadius: 10000,
      fallbackMaxDistance: 25000,
      keys: [
        { name: "icon", type: "text", default: "" },
        { name: "max_pax", type: "number", default: "4" },
        {
          name: "max_distance",
          type: "number",
          default: 25000,
        },
        { name: "fee_per_km", type: "number", default: 20 },
        { name: "min_fare", type: "number", default: 30 },
        { name: "fixed_fare_pax", type: "number", default: "-" },
        { name: "min_fare_pax", type: "number", default: "-" },
        { name: "fee_per_km_pax", type: "number", default: "-" },
        { name: "discount_type", type: "text", default: "-" },
        { name: "discount_amount", type: "number", default: "-" },
        { name: "tuk_discount", type: "number", default: 0 },
      ],
    };
  },
  computed: {
    // w() { },
    business() {
      return this.workflow.business;
    },
    updated() {
      return this.timeAgo(this.workflow.updated_at);
    },
    fixedFarePax() {
      return this.workflow.data.fixed_fare_pax;
    },
    blurb() {
      return this.workflow.data.blurb;
    },
    anyLocation() {
      return this.workflow.data.any_location;
    },
    requiresUnitNumber() {
      return this.workflow.data.requires_unit_number;
    },
    isActive() {
      return this.workflow.state !== "inactive";
    },
    hasTours() {
      var d = this.workflow.data;
      return d.tours_hourly || d.tours_itinerary;
    },
    tableData() {
      // select keys to show in table here
      var d = this.workflow.data;
      var o = {};
      this.keys.forEach((k) => {
        o[k.name] = d[k.name] || k.default;
        if (!d[k.name]) o[k.name] += " (default)";
      });
      // some post processing
      if (!d.icon) o.icon = this.workflow.name + " (default)";
      // o.icon = d.icon || this.workflow.name + " (name)";
      // o.max_pax = d.max_pax || "-";
      // o.max_distance = d.max_distance || this.fallbackMaxDistance; // default
      // o.fee_per_km = d.fee_per_km || 20; // default
      // o.min_fare = d.min_fare || 30; // default
      // o.fixed_fare_pax = d.fixed_fare_pax || "-";
      // o.min_fare_pax = d.min_fare_pax || "-";
      // o.fee_per_km_pax = d.fee_per_km_pax || "-";
      // o.discount_type = d.discount_type || "-";
      // o.discount_amount = d.discount_amount || "-";
      // o.tuk_discount = d.tuk_discount || "-";
      return o;
    },
    prettyData() {
      var d = this.workflow.data;
      var o = {
        "Fee Per KM": d.fee_per_km || "-",
        "Min Fare": d.min_fare || "-",
        "Max Distance": d.max_distance || "-",
        "Pickup Area": "-",
      };
      if (d.pickup_area_polygon) o["Pickup Area"] = "Polygon";
      else if (d.pickup_area_radius)
        o["Pickup Area"] = `Radius ${d.pickup_area_radius}m`;
      //   if (t.data.delivery.is_free_delivery) o.Order += " (Free Delivery)";
      return o;
    },
  },
  methods: {
    showPickupArea() {
      var info = "Pickup Area: Polygon";
      var d = this.workflow.data;
      if (d.pickup_area_polygon) {
        // cool
      } else if (d.pickup_area_radius) {
        info = "Pickup Area: Radius " + d.pickup_area_radius + "m";
      } else {
        info = "Pickup Area: Radius " + this.fallbackRadius + "m";
      }
      this.$swal({
        html: `<div style='font-size:1.4em'>${info}</div><br>Click to Edit`,
        showCloseButton: true,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: this.bulmaColor("success"),
        confirmButtonText: "Polygon",
        cancelButtonText: "Radius",
      }).then((val) => {
        if (val.value) this.setGeometry();
      });
    },
    setGeometry() {
      var w = this.workflow;
      this.goto(`/geometry?workflow_id=${w.id}&type=pickup_area_polygon`);
    },
    showBlurb() {
      this.$swal({
        title: "Blurb",
        html: `<div style='text-align:left'>${this.blurb}</div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    showTours() {
      // var d = this.workflow.data; // should json to yaml
      this.$swal({
        title: "Tours",
        html: `<div style='text-align:left'>tours_itinerary: true<br>tours_hourly: true</div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    gotoBusinessProfile() {
      this.goto("/business_profile/" + this.business.id);
    },
    edit(key) {
      // var kv = `"${key}": "",`;
      // this.$copyText(kv);
      // this.successToast(`Copied ${kv}`);
      this.successToast(key);
      var inputType = this.keys.find((k) => k.name === key).type;
      this.$swal({
        title: `Edit ${key}`,
        text: `Input: ${inputType}`,
        input: inputType,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (value) => {
          if (!value) return "Enter a value";
        },
      }).then((val) => {
        if (val.value) {
          var value = val.value;
          if (inputType === "number") value = parseFloat(val.value);
          this.updateWorkflowJSON(key, value);
        }
      });
    },
    updateWorkflowJSON(k, v) {
      var businessID = this.$store.state.selectedBusiness.id;
      var data = this.workflow.data;
      data[k] = v;
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          // business_id: this.w.business_id,
          // name: this.w.name,
          data: data, //JSON.parse(this.dataJSON),
        })
        .then(() => {
          this.$store
            .dispatch("getWorkflows", businessID)
            .then((res) => {
              this.workflow = res.data;
              this.successToast("JSON Saved!", "top");
            })
            .catch((err) => this.apiError(err));
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    clickable(key) {
      var keys = ["Fee Per KM", "Min Fare", "Pickup Area", "Max Distance"];
      if (keys.includes(key)) return "has-text-link editable";
    },
    // showMoreInfo(key) {
    //   var data = this.t.data;
    //   if (key === "Fare") {
    //     if (data.pickup_stop && data.dropoff_stop) {
    //       this.mapURL = this.directionsURL(data.pickup_stop, data.dropoff_stop);
    //     } else if (data.address && data.business) {
    //       this.mapURL = this.directionsURL(data.business, data.address);
    //     } else return;
    //     this.moreInfo = "View driving route";
    //     return;
    //   }
    //   // just show coords and link to google location
    //   var p = null;
    //   if (key === "Pickup") {
    //     p = data.pickup_stop;
    //     this.moreInfo = `Pickup: ${p.lat}, ${p.lon}`;
    //   }
    //   if (key === "Dropoff") {
    //     p = data.dropoff_stop;
    //     this.moreInfo = `Dropoff: ${p.lat}, ${p.lon}`;
    //   }
    //   if (key === "Shop") {
    //     p = data.business;
    //     this.moreInfo = `Shop: ${p.lat}, ${p.lon}`;
    //   }
    //   if (key === "Address") {
    //     p = data.address;
    //     this.moreInfo = `Address: ${p.lat}, ${p.lon}`;
    //   }
    //   if (p) this.mapURL = this.googleMapURL(p);
    // },
    directionsURL(s, d) {
      var scoords = `${s.lat},${s.lon}`;
      var dcoords = `${d.lat},${d.lon}`;
      return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`;
    },
    googleMapURL(coords) {
      return `http://www.google.com/maps/place/${coords.lat},${coords.lon}`;
    },
    gotoMapURL() {
      window.open(this.mapURL, "_blank");
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: rgba(0, 0, 0, 0.9); */
  background-color: rgba(57, 6, 120, 0.95);
  z-index: 1100;
  /* random z-index higher than modal */
  backdrop-filter: blur(3px);
  overflow: hidden;
}
.wrapper {
  padding: 16px;
  text-align: left;
  height: 100vh;
}
.table-wrapper {
  overflow: scroll;
  height: 280px;
  /* margin-bottom: 12px; */
}
/* .table {
  margin-bottom: 0px;
  padding-bottom: 0px;
} */
.subtitle {
  color: lightcyan;
  font-weight: 450;
  font-size: 1.1em;
  margin-top: 3px;
  margin-bottom: 16px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  background-color: rgba(135, 84, 255, 0.744);
}
.key {
  font-weight: 550;
  color: rgba(84, 84, 84, 0.7);
  padding-right: 0;
}
.editable {
  font-weight: 450;
  opacity: 0.9;
}
.updated {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 10px;
  z-index: 1101;
}
td .tag {
  margin-right: 4px;
}
.top-row {
  display: inline-block;
  max-width: calc(100vw - 60px);
  white-space: nowrap;
  overflow: auto;
  vertical-align: bottom;
}
</style>